import React, { useState } from 'react';
import TermsModal from '../TermsModal';

const CONTACT_EMAIL = "support@immunoact.com";

const Footer = () => {
  const [showTerms, setShowTerms] = useState(false);

  return (
    <>
      <footer className="bg-white border-t border-gray-200 mt-auto">
        <div className="max-w-5xl mx-auto px-6 py-2">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-2 md:space-y-0">
            {/* Left logo */}
            <img
              src="/ImmunoACT-Logo-No-Background.png"
              alt="ImmunoACT"
              className="h-10 w-auto"
            />

            {/* Center content */}
            <div className="text-center leading-relaxed">
              <div className="text-xs text-gray-500">
                © {new Date().getFullYear()} Immunoadoptive Cell Therapy Private Limited. All rights reserved. &nbsp;·&nbsp;{' '}
                <span
                  onClick={() => setShowTerms(true)}
                  className="text-blue-600 font-semibold cursor-pointer underline"
                >
                  Terms &amp; Conditions
                </span>
              </div>
              <div className="text-xs text-gray-400">
                IT support:{' '}
                <a href="mailto:digital@immunoact.com" className="text-blue-600">digital@immunoact.com</a>
                {' '}&nbsp;·&nbsp;{' '}
                Medical support:{' '}
                <a href="mailto:brian.bernard@immunoact.com" className="text-blue-600">brian.bernard@immunoact.com</a>
              </div>
            </div>

            {/* Right logo */}
            <img
              src="/The Hope Initiative transparent.png"
              alt="The Hope Initiative"
              className="h-10 w-auto"
            />
          </div>
        </div>
      </footer>

      {/* Reuse the existing TermsModal in read-only mode */}
      <TermsModal
        isOpen={showTerms}
        onClose={() => setShowTerms(false)}
        mode="read"
      />
    </>
  );
};

export default Footer;
